'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _livePersonManager = require('../live-person-manager');

var _livePersonManager2 = _interopRequireDefault(_livePersonManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var visitorClosedEvent = 'visitorClosed';
/**
 * BotActionWaitTimeClock
 *
 * @Constructor
 * @class BotActionWaitTimeClock
 * @public
 */

var BotActionWaitTimeClock = function (_React$Component) {
  _inherits(BotActionWaitTimeClock, _React$Component);

  function BotActionWaitTimeClock(props) {
    _classCallCheck(this, BotActionWaitTimeClock);

    var _this = _possibleConstructorReturn(this, (BotActionWaitTimeClock.__proto__ || Object.getPrototypeOf(BotActionWaitTimeClock)).call(this, props));

    _this.leaveQueue = _this.leaveQueue.bind(_this);
    return _this;
  }

  _createClass(BotActionWaitTimeClock, [{
    key: 'leaveQueue',
    value: function leaveQueue() {
      _livePersonManager2.default.endConnection(visitorClosedEvent);
    }

    /**
     * @returns {React.Element} render
     *
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      var waitTime = this.props.estimatedChatWaitTime;

      return _react2.default.createElement(
        'div',
        { className: 'wait-time-container' },
        _react2.default.createElement(
          'div',
          { className: 'finding-agent' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Support:HelpBot:LiveEngage:AgentFind' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'estimated-wait-time' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Support:HelpBot:LiveEngage:EstimatedWaitTime', values: { waitTime: waitTime } })
        ),
        _react2.default.createElement(
          'div',
          { className: 'clock-dial' },
          _react2.default.createElement('div', { className: 'minute-hand' }),
          _react2.default.createElement('div', { className: 'hour-hand' })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'leave-queue',
            onClick: this.leaveQueue,
            onKeyPress: function onKeyPress() {},
            role: 'button',
            tabIndex: '0'
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Support:HelpBot:LiveEngage:LeaveChatQueue' })
        )
      );
    }
  }]);

  return BotActionWaitTimeClock;
}(_react2.default.Component);

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


exports.default = BotActionWaitTimeClock;
BotActionWaitTimeClock.propTypes = {
  estimatedChatWaitTime: _propTypes2.default.string.isRequired
};